/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {customerLastActivityInternal} from '../api'

export const useMutationCustomerLastActivityInternal = createReactQueryMutationHook('customerLastActivityInternal', customerLastActivityInternal)
